export const texts = {
  ERROR: 'Please make sure field is valid',
};
